export const VERSIONS = {
    FALLBACK: '1',
    V1: '1',
    V2: '2',
} as const;

export type VERSION = (typeof VERSIONS)[keyof typeof VERSIONS];

export const DOMAINS = {
    FIVERR: '',
    BUSINESS: 'business',
} as const;

export const DEFAULT_DOMAIN = DOMAINS.FIVERR;

export const DEFAULT_SEARCH_TERM = 'logo design';

export const MODES = {
    SPECIFIC_GIG: 'specific_gig',
    RANDOM_GIGS: 'random_gigs',
} as const;

export type MODE = (typeof MODES)[keyof typeof MODES];

export const WEBSITE_LANGUAGES = {
    ENGLISH: {
        text: 'English',
        value: 'en',
    },
    GERMAN: {
        text: 'Deutsch',
        value: 'de',
    },
    SPANISH: {
        text: 'Español',
        value: 'es',
    },
    FRENCH: {
        text: 'Français',
        value: 'fr',
    },
    PORTUGUESE: {
        text: 'Português',
        value: 'br',
    },
    ITALIAN: {
        text: 'Italiano',
        value: 'it',
    },
    DUTCH: {
        text: 'Nederlands',
        value: 'nl',
    },
};

export const DEFAULT_WEBSITE_LANGUAGE = WEBSITE_LANGUAGES.ENGLISH.value;
